
import { Injectable } from '@angular/core';
import * as AppTypes from './appDefs';
  

   const Note = [
            'C',
            'Db',
            'D',
            'Eb',
            'E',
            'F',
            'Gb',
            'G',
            'Ab',
            'A',
            'Bb',
       'B'];

       const NoteHash = [
        'C',
        'C#',
        'D',
        'D#',
        'E',
        'F',
        'F#',
        'G',
        'G#',
        'A',
        'A#',
   'B'];


   const NoteSharp = [
    'C',
    'CS',
    'D',
    'DS',
    'E',
    'F',
    'FS',
    'G',
    'GS',
    'A',
    'AS',
'B'];
    // Octave free Indian Notes
   const NoteHindi=[
            'White 1',
            'Black 1',
            'White 2',
            'Black 2',
            'White 3',
            'White 4',
            'Black 3',
            'White 5',
            'Black 4',
            'White 6',
            'Black 5',
            'White 7'
   ];
      const octaveFreeNumberToNote=['S','r','R','g','G','m','M','P','d','D','n','N'];
   const  OctavedIndianNotes=['Lower Sa',
                     'Lower Komal Re',
                     'Lower Re',
                     'Lower Komal Ga',
                     'Lower Ga',
                     'Lower Madhyam',
                     'Lower Tivra Madhyam',
                     'Lower Pancham',
                     'Lower Komal Dha',
                     'Lower Dha',
                     'Lower Komal Ni',
                     'Lower Ni',
                     'Sa',
                     'Komal Re',
                     'Re',
                     'Komal Ga',
                     'Ga',
                     'Madhyam',
                     'Tivra Madhhyam',
                     'Pancham',
                     'Komal Dha',
                     'Dha',
                     'Komal Ni',
                     'Ni',
                     'Higher Sa',
                     
                     'Higher Komal Re',
                     'Higher Re',
                     'Higher Komal Ga',
                     'Higher Ga',
                     'Higher Madhyam',
                     'Higher Tivra Madhyam',
                     'Higher Pancham',
                     'Higher Komal Dha',
                     'Higher Dha',
                     'Higher Komal Ni',
                     'Higher Ni'
                     
                     ];

                     const  OctavedWesternSargam=['3C',
                     '3C#',
                     '3D',
                     '3D#',
                     '3E',
                     '3F',
                     '3F#',
                     '3G',
                     '3G#',
                     '3A',
                     '3A#',
                     '3B',
                    
                    '4C',
                    '4C#',
                     '4D',
                     '4D#',
                     '4E',
                     '4F',
                     '4F#',
                     '4G',
                     '4G#',
                     '4A',
                     '4A#',
                     '4B',

                    
                     '5C',
                     '5C#',
                     '5D',
                     '5D#',
                     '5E',
                     '5F',
                     '5F#',
                     '5G',
                     '5G#',
                     '5A',
                     '5A#',
                     '5B',
                     ];
const noteFull = {
            r: 'Komal Re',
            R: 'Shuddh Re',
            g:'Komal Gaa',
            G: 'Shuddh Gaa',
            m: 'Shuddh Maa',
            s: 'Shadja',
            S: 'Shadja',
            p: 'Pancham',
            P:'Pancham',
            M: 'Tivra  Maa',
            d: 'Komal Dha',
            n: 'Komal Ni',
            D: 'Shuddh Dha',
            N:'Shuddh Ni'
};

const  shrutiOptionsData = {
    'r': [{ name: 'Dayavati 256/243', freq: 256 / 243, tag: 'r1' }, { name: 'Ranjani 16/15', freq: 16 / 15, tag: 'r2' }, { name: 'default', freq: 16 / 15, tag: 'r' }],

    'R': [{ name: 'Ratika 10/9', freq: 10 / 9, tag: 'R1' }, { name: 'Raudri 9/8', freq: 9 / 8, tag: 'R2' }, { name: 'default', freq: 9 / 8, tag: 'R' }],
    'g': [{ name: 'Krodha 32/27', freq: 32 / 27, tag: 'g1' }, { name: 'Vajrika 6/5', freq: 6 / 5, tag: 'g2' }, { name: 'default', freq: 6 / 5, tag: 'g' }],
    'G': [{ name: 'Prasarini 5/4', freq: 5 / 4, tag: 'G1' }, { name: 'Priti 81/64', freq: 81 / 64, tag: 'G2' }, { name: 'default', freq: 5 / 4, tag: 'G' }],
    'm': [{ name: 'Marjini 4/3', freq: 4 / 3, tag: 'm1' }, { name: 'Kshiti 27/20', freq: 27 / 20, tag: 'm2' }, { name: 'default', freq: 4 / 3, tag: 'm' }],
    'M': [{ name: 'Rakta 45/32', freq: 45 / 32, tag: 'M1' }, { name: 'Sandipani 729/512', freq: 729 / 512, tag: 'M2' }, { name: 'default', freq: 45 / 32, tag: 'M' }],
    'd': [{ name: 'Madanti 128/81', freq: 128 / 81, tag: 'd1' }, { name: 'Rohini 8/5', freq: 8 / 5, tag: 'd2' }, { name: 'default', freq: 8 / 5, tag: 'd' }],
    'D': [{ name: 'Ramya 5/3', freq: 5 / 3, tag: 'D1' }, { name: 'Ugra 27/16', freq: 27 / 16, tag: 'D2' }, { name: 'default', freq: 5 / 3, tag: 'D' }],
    'n': [{ name: 'Kshobhini 16/9', freq: 16 / 9, tag: 'n1' }, { name: 'Tivra 9/5', freq: 9 / 5, tag: 'n2' }, { name: 'default', freq: 9 / 5, tag: 'D' }],
    'N': [{ name: 'Kumdavati 15/8', freq: 15 / 8, tag: 'N1' }, { name: 'Manda 243/128', freq: 243 / 128, tag: 'N2' }, { name: 'default', freq: 15 / 8, tag: 'N' }],

};
@Injectable({
    providedIn: 'root'
  })
export class Melody {


fineTune: number=0;
scaleNumber: number=0;
octavedWesternSargam=OctavedWesternSargam;
    octavedNoteToNumber= {} as AppTypes.StringObjMap;    
    defaultShrutiMap=new Map();
    currentShrutiMap = null;
    keyBoardBase = 440;
    indianOctaveScalesArray;
constructor() {
    let s = this.octavedNoteToNumber;
        s[".S"] = -12;
    s[".r"] = -11;
    s[".R"] = -10;
    s[".g"] = -9;
    s[".G"] = -8;
    s[".m"] = -7;
    s[".M"] = -6;
    s[".P"] = -5;
    s[".d"] = -4;
    s[".D"] = -3;
    s[".n"] = -2;
    s[".N"] = -1;
    s["S"] = 0;
    s["r"] = 1;

    s["R"] = 2;
    s["g"] = 3;
    s["G"] = 4;
    s["m"] = 5;
    s["M"] = 6;
    s["P"] = 7;
    s["d"] = 8;
    s["D"] = 9;
    s["n"] = 10;
    s["N"] = 11;
    s["S'"] = 12;


    s["r'"] = 1 + 12;

    s["R'"] = 2 + 12;
    s["g'"] = 3 + 12;
    s["G'"] = 4 + 12;
    s["m'"] = 5 + 12;
    s["M'"] = 6 + 12;
    s["P'"] = 7 + 12;
    s["d'"] = 8 + 12;
    s["D'"] = 9 + 12;
    s["n'"] = 10 + 12;
    s["N'"] = 11 + 12;



  let keyNotes=Object.keys(shrutiOptionsData);
  let i=0;
    this.currentShrutiMap=new Map();
  for (i=0; i < keyNotes.length;i++)
  {
  let shrutis=shrutiOptionsData[keyNotes[i]];
  let pg=this;
  shrutis.forEach(function (s) { if (s.name == 'default')
                  
                  {
                  pg.defaultShrutiMap[keyNotes[i]] =s;
                    pg.currentShrutiMap[keyNotes[i]] =s;
                  }
                  });
  }


  this.indianOctaveScalesArray=this.indianOctaveScale();
  this.computeTaanpuraStrings();
}
    
SaFreqNoadjust ()
{
    // compute Sa Frequency         
        return( 261.63 *Math.pow(2,this.scaleNumber/12));
  }
   
    numberToSur(note) {

        var octave = 0;
        var suffix = '';
        if (note < 0) {
            octave = -1;
            suffix = '.';
        }
         if (note < -11) {
            octave = -2;
            suffix = '..';
        }
        if (note > 11) {
            octave = 1;
            suffix = "'";
        }
         if (note > 23) {
            octave = 2;
            suffix = "''";
        }
        note -= 12 * octave;

        var sur = octaveFreeNumberToNote[note];

        return ({ sur: sur, saptak: octave, octaved: sur + suffix , fullIndian: OctavedIndianNotes[note + (1 + octave) * 12]
    });

  }
  
    noteToFreq(note)
/* Note can be a number -12 to 24 or string
* */

  {
     
    

      var octave=0;
      var noteNum=0;
      if (note == null)
          {
          return null;
          }
      if (!Number.isInteger(note))
          {
         if (note.indexOf('p')!=-1)
            note=note.toLocaleUpperCase();
        if (note.indexOf('s')!=-1)
            note=note.toLocaleUpperCase(); 
         noteNum=this.octavedNoteToNumber[note];
          }
      
      else
          {
          noteNum=note;
          }
        let noteNumBase = noteNum;
        
           if (noteNum < 0) 
          
               {
               octave=-1;
               noteNumBase= noteNum - octave * 12;
               } else
                   {
                       if (noteNum > 11)
                       {
                       octave = 1;
                       noteNumBase = noteNum -octave * 12;
                       }
                   }
               
          
           
         
           let pitchShift=this.fineTune/50;
           let fractionScale=this.scaleNumber+pitchShift;
       let baseFreq=261.63 *Math.pow(2,fractionScale/12);
          // find note based on this Sa. Std 440 for A4. C4 ->base
       let index=octaveFreeNumberToNote[noteNumBase]
        let freqRatio=this.getFreqRatio(index);

        if (octave ==1)
            {
            freqRatio =freqRatio *2;
            }
        if (octave == -1)
            {
            freqRatio =freqRatio /2;
        }
        let adjust = this.keyBoardBase / 440;
        return (baseFreq * freqRatio *adjust);

      
  }
    intToNote(n)
/* number between -12 to +24 */
  {
      if (n==null)
      return '';
        if (n < -12)
            return '';

      let xn=n+12;
      let note="";
        if (n < 0)
        // Madnra Saptak
          {
          note=".";
        }
        // Get note
        note = note + octaveFreeNumberToNote[xn % 12];
        // Taar Saptak
      if (xn > 23)        {
          note = note+"'";
          }
    
      return note;
  }
  




                    
                    
   shrutiOptions (note)
  {

  if (shrutiOptionsData[note]===undefined)
  {
      console.log('Note ', note);  
      return null;
  }
   return shrutiOptionsData[note];
  }

    /* get freq ratio wrt Sa. Not accounting for octave*/
    getFreqRatio (note)
    {
        if (!note)
        {
            console.log("null passed")
            debugger;
            return;
        }
      
        let index = note;
          if (index =='S')
          return  (1);
          if (index =='s')
          return  (1);
          if (index=='P')
          return 1.5;
          if (index=='p')
          return 1.5;
         
          
            let realNote=this.currentShrutiMap[index];
            if (!realNote)
            realNote=this.defaultShrutiMap[index]
            return (realNote.freq);
      }
                      
    getDefaultShruti  () {
        return (this.defaultShrutiMap);
    }
    setShruti (shruti)
    {
        this.currentShrutiMap = shruti;
    }

    strToNumScale(str)
    {
        let myInd=0;
        let mNote;
    mNote=Note.filter((a,index)=>{ if (a==str) myInd=index; return (a==str);});
    if (mNote[0])
        return myInd;
        myInd=0;
        mNote=NoteHash.filter((a,index)=>{ if (a==str) myInd=index; return (a==str);});
        if (mNote[0])
            return myInd;
              

        myInd=0;
        mNote=NoteSharp.filter((a,index)=>{ if (a==str) myInd=index; return (a==str);});
        if (mNote[0])
            return myInd;
              
    }

    indianOctaveScale()
    {
       let  result=[];
        Object.keys(this.octavedNoteToNumber).forEach(a=>{
            let abbr=a;
            let index=this.octavedNoteToNumber[a];
            let western=OctavedWesternSargam[index+12]
            let descr=OctavedIndianNotes[index+12];
            if (AppTypes.defined(descr))
            {
                result.push ({abbr:abbr,western:western,descr:descr,indexInt:index})
            }
        });
        return result;
    }
    taanpuraStrings=[]

    computeTaanpuraStrings()
    {
    let result=[];
    result.push({note:'S',decr:'Shadja'});
    Object.keys(noteFull).forEach((note)=>
    {
        result.push({note:note,descr:noteFull[note]})
    });
    this.taanpuraStrings=result;
    }

    scaleNumToString(n)
    {
        if (n >=0 && n<12)
        {
            return (NoteHash[n] + " "+ NoteHindi[n])
        }
       else  return " ";
    }

    westernToMidi(note: string)
    {
        if (!note) {
            return null;
        }
        const trimmed = note.trim();
        const match = /^(\-?\d+)?\s*([A-Ga-g])\s*([#b]?)/.exec(trimmed);
        if (!match) {
            return null;
        }

        let octave = parseInt(match[1] ?? '4', 10);
        const letter = match[2].toUpperCase();
        const accidental = match[3] ?? '';

        const baseMap = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
        let semitone = baseMap[letter];
        if (semitone === undefined) {
            return null;
        }
        if (accidental === '#') {
            semitone += 1;
        } else if (accidental === 'b') {
            semitone -= 1;
        }

        if (semitone < 0) {
            semitone += 12;
            octave -= 1;
        } else if (semitone >= 12) {
            semitone -= 12;
            octave += 1;
        }

        return (octave + 1) * 12 + semitone;
    }
                      
   }
                      
